import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    /** Evita que cada 401 de un lote en paralelo dispare su propia salida. */
    private redirecting = false;

    constructor(private authenticationService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401 && !this.redirecting) {
                this.redirecting = true;
                // auto logout if 401 response returned from api
                this.goToLogin();
            }

            // Pass through the normalized error object
            return throwError(() => err);
        }));
    }

    /**
     * Saca al usuario al login con una carga completa del documento.
     *
     * Antes esto era `window.location.reload()`: volvía a arrancar la app sobre la
     * MISMA ruta protegida, que pedía datos otra vez, recibía otro 401 y recargaba
     * de nuevo. Se veían hasta cinco arranques del bundle —varios segundos en
     * blanco— antes de llegar al login. Sigue siendo una carga de documento y no
     * `router.navigate` a propósito: así se tira también el estado en memoria de
     * los servicios (perfil cacheado, grupo memoizado) que quedó del usuario anterior.
     */
    goToLogin(): void {
        this.authenticationService.leaveToLogin();
    }
}
